/**
 * Améliore le switcher Weglot : bouton avec icon-langues.svg, styles .ui-dropdown,
 * et langue active visible aussi dans la liste déroulante.
 *
 * Important : ne pas observer les changements de classe sur le switcher tout en
 * modifiant ces classes (syncSelectedState), sinon boucle infinie.
 */
(function () {
  const ATTR = 'data-weglot-enhanced';
  const ATTR_PROCESSING = 'data-weglot-enhancing';
  const MOBILE_MEDIA_QUERY = '(max-width: 989px)';
  let headerWeglotReadyNotified = false;

  function notifyHeaderWeglotReady(container) {
    if (headerWeglotReadyNotified) return;
    if (!container || !container.closest('.section-header')) return;
    headerWeglotReadyNotified = true;
    document.dispatchEvent(new CustomEvent('theme:header-weglot-ready'));
  }

  function notifyIfHeaderWeglotAlreadyEnhanced() {
    const enhanced = document.querySelector(
      '.section-header .weglot-container[' + ATTR + '="true"]'
    );
    if (enhanced) notifyHeaderWeglotReady(enhanced);
  }

  function getIconUrl() {
    return (window.themeWeglot && window.themeWeglot.langIconUrl) || '';
  }

  function getIconSvg() {
    return (window.themeWeglot && window.themeWeglot.langIconSvg) || '';
  }

  function closeAllExcept(openRoot) {
    document.querySelectorAll('.weglot-ui-dropdown.is-open').forEach((el) => {
      if (el !== openRoot) {
        el.classList.remove('is-open');
        const m = el.querySelector('.language-list');
        const t = el.querySelector('.weglot-ui-trigger');
        const sw = el.querySelector('.weglot_switcher');
        if (m) {
          m.setAttribute('hidden', '');
          m.style.display = 'none';
        }
        if (t) t.setAttribute('aria-expanded', 'false');
        if (sw) {
          sw.classList.add('closed');
          sw.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  function syncSelectedState(root) {
    const current =
      root.querySelector('.weglot_switcher > .language-option.wgcurrent') ||
      root.querySelector('.language-option.active-language') ||
      root.querySelector('.language-option.wgcurrent');
    const code = current && current.getAttribute('data-l');
    if (!code) return;

    root.querySelectorAll('.language-list .language-option').forEach((opt) => {
      const c = opt.getAttribute('data-l');
      opt.classList.toggle('is-selected', c === code);
      opt.classList.add('ui-dropdown__option');
    });
  }

  function cleanupListDuplicates(container) {
    const list = container.querySelector('.language-list');
    if (!list) return;

    // Keep at most one cloned current option and one native option per language code.
    const seenNativeByCode = new Set();
    const seenCloneByCode = new Set();

    Array.from(list.querySelectorAll('.language-option')).forEach((opt) => {
      const code = opt.getAttribute('data-l') || '';
      const isClone = opt.hasAttribute('data-weglot-clone-current');

      if (isClone) {
        if (seenCloneByCode.has(code)) {
          opt.remove();
          return;
        }
        seenCloneByCode.add(code);
        return;
      }

      if (seenNativeByCode.has(code)) {
        opt.remove();
        return;
      }
      seenNativeByCode.add(code);
    });
  }

  function ensureCurrentLanguageInList(container) {
    const switcher = container.querySelector('.weglot_switcher');
    const list = container.querySelector('.language-list');
    if (!switcher || !list) return;

    cleanupListDuplicates(container);

    const current =
      switcher.querySelector(':scope > .language-option.wgcurrent') ||
      switcher.querySelector(':scope > .language-option.active-language');

    if (!current || current.closest('.language-list')) return;

    const code = current.getAttribute('data-l');
    if (!code) return;

    const safeCode = String(code).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const existingClone = list.querySelector(
      '.language-option[data-weglot-clone-current="true"][data-l="' + safeCode + '"]'
    );
    if (existingClone) {
      syncSelectedState(container.closest('.weglot-ui-dropdown') || container);
      return;
    }

    // Remove stale clone(s) from previous selected language to avoid drift.
    list
      .querySelectorAll('.language-option[data-weglot-clone-current="true"]')
      .forEach((node) => node.remove());

    const clone = current.cloneNode(true);
    clone.setAttribute('data-weglot-clone-current', 'true');
    clone.classList.add('ui-dropdown__option');
    clone.classList.remove('weglot-ui-hidden-current');
    clone.removeAttribute('aria-hidden');
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    list.insertBefore(clone, list.firstChild);
    syncSelectedState(container.closest('.weglot-ui-dropdown') || container);
  }

  function hideNativeCurrentRow(container) {
    const switcher = container.querySelector('.weglot_switcher');
    if (!switcher) return;

    const children = Array.from(switcher.children);
    const listEl = children.find((c) => c.classList && c.classList.contains('language-list'));
    const currentRow = children.find(
      (c) =>
        c.classList &&
        c.classList.contains('language-option') &&
        !c.classList.contains('language-list')
    );

    if (currentRow) {
      currentRow.classList.add('weglot-ui-hidden-current');
      currentRow.setAttribute('aria-hidden', 'true');
    }

    if (listEl) {
      listEl.classList.add('ui-dropdown__menu');
      listEl.setAttribute('hidden', '');
      listEl.style.display = 'none';

      // The current language row must stay hidden only outside the list.
      listEl
        .querySelectorAll('.language-option.weglot-ui-hidden-current')
        .forEach((node) => node.classList.remove('weglot-ui-hidden-current'));
    }
  }

  let documentClickBound = false;
  let resizeBound = false;

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function getHeaderIconsNode() {
    return document.querySelector('.section-header .header__icons');
  }

  function getMenuDrawerWeglotSlot() {
    return document.querySelector('[data-weglot-drawer-slot]');
  }

  function getDrawerPlacementTarget() {
    return getMenuDrawerWeglotSlot() || document.querySelector('.menu-drawer__navigation');
  }

  function isWeglotInDrawer(node) {
    return Boolean(node && node.closest('[data-weglot-drawer-slot], .menu-drawer__navigation'));
  }

  function getWeglotHeaderHomeParent() {
    const headerIcons = getHeaderIconsNode();
    if (!headerIcons) return null;
    return headerIcons.querySelector('.desktop-localization-wrapper') || headerIcons;
  }

  function rememberWeglotHeaderHome(node) {
    if (!node || node.__weglotHeaderHomeParent) return;
    const home = getWeglotHeaderHomeParent();
    if (home) node.__weglotHeaderHomeParent = home;
  }

  function isWeglotInHeaderNavbar(node) {
    if (!node || isWeglotInDrawer(node)) return false;
    const siteHeader = document.querySelector('.site-header-group, .section-header');
    return Boolean(siteHeader && siteHeader.contains(node));
  }

  function pruneDrawerWeglotExcept(keepNode) {
    const slot = getMenuDrawerWeglotSlot();
    if (!slot) return;

    slot.querySelectorAll(':scope > .weglot-ui-dropdown, :scope > .weglot-container').forEach((el) => {
      if (!keepNode) {
        el.remove();
        return;
      }
      if (el === keepNode || keepNode.contains(el) || el.contains(keepNode)) return;
      el.remove();
    });
  }

  function moveNodeToDrawer(node) {
    const target = getDrawerPlacementTarget();
    if (!node || !target) return false;

    rememberWeglotHeaderHome(node);
    const container = node.classList.contains('weglot-container')
      ? node
      : node.querySelector('.weglot-container');
    if (container) rememberWeglotHeaderHome(container);

    pruneDrawerWeglotExcept(node);
    if (node.parentElement !== target) {
      target.appendChild(node);
    }
    return true;
  }

  /** Mobile : retirer le switcher du flex navbar dès l’injection (avant enrichissement). */
  function stashHeaderWeglotForMobile(node) {
    if (!node || !isMobileViewport()) return;
    if (!isWeglotInHeaderNavbar(node)) return;
    moveNodeToDrawer(node);
  }

  function stashAllHeaderWeglotForMobile() {
    if (!isMobileViewport()) return;

    const headerWeglotSelector =
      '.site-header-group .header__icons .weglot-container, ' +
      '.site-header-group .header__icons .weglot-ui-dropdown:not(.weglot-ui-dropdown--in-drawer), ' +
      '.section-header .header__icons .weglot-container, ' +
      '.section-header .header__icons .weglot-ui-dropdown:not(.weglot-ui-dropdown--in-drawer)';

    document.querySelectorAll(headerWeglotSelector).forEach((node) => {
      stashHeaderWeglotForMobile(node);
      if (node.classList.contains('weglot-ui-dropdown')) {
        placeWrapperForViewport(node);
      }
    });

    document
      .querySelectorAll('.weglot-ui-dropdown--in-drawer')
      .forEach((wrapper) => placeWrapperForViewport(wrapper));
  }

  function placeWrapperForViewport(wrapper) {
    if (!wrapper) return;

    if (isMobileViewport()) {
      const target = getDrawerPlacementTarget();
      if (target) {
        if (wrapper.parentElement !== target) {
          pruneDrawerWeglotExcept(wrapper);
          target.appendChild(wrapper);
        }
        wrapper.classList.add('weglot-ui-dropdown--in-drawer');
      }
      return;
    }

    const container = wrapper.querySelector('.weglot-container');
    const originalParent =
      wrapper.__originalParent ||
      (container && container.__weglotHeaderHomeParent) ||
      wrapper.__originalParent;
    const originalNextSibling = wrapper.__originalNextSibling;
    if (!originalParent) return;

    if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
      originalParent.insertBefore(wrapper, originalNextSibling);
    } else if (wrapper.parentElement !== originalParent) {
      originalParent.appendChild(wrapper);
    }
    wrapper.classList.remove('weglot-ui-dropdown--in-drawer');
  }

  function placeAllWrappersForViewport() {
    document
      .querySelectorAll('.weglot-ui-dropdown')
      .forEach((wrapper) => placeWrapperForViewport(wrapper));
  }

  function wireOpenClose(wrapper, container) {
    const btn = wrapper.querySelector('.weglot-ui-trigger');
    const list = container.querySelector('.language-list');
    const switcher = container.querySelector('.weglot_switcher');
    if (!btn || !list) return;

    const toggle = (open) => {
      if (open) {
        closeAllExcept(wrapper);
        wrapper.classList.add('is-open');
        list.removeAttribute('hidden');
        list.style.display = '';
        btn.setAttribute('aria-expanded', 'true');
        if (switcher) {
          switcher.classList.remove('closed');
          switcher.setAttribute('aria-expanded', 'true');
        }
      } else {
        wrapper.classList.remove('is-open');
        list.setAttribute('hidden', '');
        list.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
        if (switcher) {
          switcher.classList.add('closed');
          switcher.setAttribute('aria-expanded', 'false');
        }
      }
    };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const willOpen = !wrapper.classList.contains('is-open');
      toggle(willOpen);
    });

    list.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (link) {
        toggle(false);
      }
    });

    if (!documentClickBound) {
      documentClickBound = true;
      document.addEventListener(
        'click',
        (e) => {
          document.querySelectorAll('.weglot-ui-dropdown.is-open').forEach((w) => {
            if (!w.contains(e.target)) {
              w.classList.remove('is-open');
              const m = w.querySelector('.language-list');
              const t = w.querySelector('.weglot-ui-trigger');
              const sw = w.querySelector('.weglot_switcher');
              if (m) {
                m.setAttribute('hidden', '');
                m.style.display = 'none';
              }
              if (t) t.setAttribute('aria-expanded', 'false');
              if (sw) {
                sw.classList.add('closed');
                sw.setAttribute('aria-expanded', 'false');
              }
            }
          });
        },
        true
      );
    }

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!wrapper.classList.contains('is-open')) return;
      toggle(false);
      btn.focus();
    });
  }

  function enhanceContainer(container) {
    if (!container) return;
    if (container.getAttribute(ATTR) === 'true') return;
    if (container.getAttribute(ATTR_PROCESSING) === 'true') return;

    try {
      const switcher = container.querySelector('.weglot_switcher');
      const list = container.querySelector('.language-list');
      if (!switcher || !list) return;

      const parent = container.parentElement;
      if (!parent) return;

      container.setAttribute(ATTR_PROCESSING, 'true');

      rememberWeglotHeaderHome(container);
      if (isMobileViewport() && isWeglotInHeaderNavbar(container)) {
        stashHeaderWeglotForMobile(container);
      }

      const homeParent = container.__weglotHeaderHomeParent || getWeglotHeaderHomeParent() || parent;

      const wrapper = document.createElement('div');
      wrapper.className = 'ui-dropdown weglot-ui-dropdown';
      wrapper.__originalParent = homeParent;
      wrapper.__originalNextSibling = container.nextSibling || null;

      parent.insertBefore(wrapper, container);
      wrapper.appendChild(container);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ui-dropdown__trigger weglot-ui-trigger';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-haspopup', 'listbox');
      const labelEl = container.querySelector('[aria-label]');
      const label =
        container.getAttribute('aria-label') || (labelEl && labelEl.getAttribute('aria-label')) || 'Langue';
      btn.setAttribute('aria-label', label);

      const svgMarkup = getIconSvg();
      if (svgMarkup) {
        const iconWrap = document.createElement('span');
        iconWrap.className = 'weglot-ui-trigger__icon';
        iconWrap.innerHTML = svgMarkup;
        const svg = iconWrap.querySelector('svg');
        if (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        }
        btn.appendChild(iconWrap);
      } else {
        const url = getIconUrl();
        if (url) {
          const img = document.createElement('img');
          img.src = url;
          img.alt = '';
          img.width = 24;
          img.height = 24;
          img.decoding = 'async';
          img.className = 'weglot-ui-trigger__icon';
          btn.appendChild(img);
        }
      }

      wrapper.insertBefore(btn, container);

      hideNativeCurrentRow(container);
      ensureCurrentLanguageInList(container);

      list.querySelectorAll('.language-option').forEach((opt) => {
        opt.classList.add('ui-dropdown__option');
      });
      syncSelectedState(wrapper);

      wireOpenClose(wrapper, container);
      placeWrapperForViewport(wrapper);

      container.setAttribute(ATTR, 'true');
      container.removeAttribute(ATTR_PROCESSING);
      notifyHeaderWeglotReady(container);

      // Uniquement structure enfants : pas d'attributes (évite boucle avec syncSelectedState).
      const obs = new MutationObserver(() => {
        try {
          ensureCurrentLanguageInList(container);
          hideNativeCurrentRow(container);
          list.querySelectorAll('.language-option').forEach((opt) => {
            opt.classList.add('ui-dropdown__option');
          });
          syncSelectedState(wrapper);
        } catch (err) {
          console.warn('[weglot-dropdown-enhance]', err);
        }
      });
      obs.observe(switcher, { childList: true, subtree: true });
    } catch (err) {
      console.warn('[weglot-dropdown-enhance] enhanceContainer', err);
      try {
        container.removeAttribute(ATTR_PROCESSING);
        container.removeAttribute(ATTR);
      } catch (e2) {
        /* ignore */
      }
    }
  }

  let globalMo = null;
  let debounceId = null;
  let drawerToggleBound = false;
  let weglotHookBound = false;

  function bindMenuDrawerResync() {
    if (drawerToggleBound) return;
    const drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (!drawerDetails) return;
    drawerToggleBound = true;
    drawerDetails.addEventListener('toggle', () => {
      if (!drawerDetails.open) return;
      scan();
      placeAllWrappersForViewport();
    });
  }

  function bindWeglotLifecycle() {
    if (weglotHookBound) return;
    const attach = () => {
      const wg = window.Weglot;
      if (!wg) return false;
      weglotHookBound = true;
      const resync = () => scheduleScanDebounced();
      if (typeof wg.on === 'function') {
        try {
          wg.on('initialized', resync);
          wg.on('languageChanged', resync);
        } catch (err) {
          console.warn('[weglot-dropdown-enhance] Weglot.on', err);
        }
      }
      return true;
    };
    if (attach()) return;
    let attempts = 0;
    const poll = window.setInterval(() => {
      attempts += 1;
      if (attach() || attempts > 40) {
        window.clearInterval(poll);
      }
    }, 250);
  }

  function scan() {
    if (globalMo) {
      globalMo.disconnect();
    }
    try {
      bindMenuDrawerResync();
      stashAllHeaderWeglotForMobile();
      document
        .querySelectorAll(
          '.weglot-container:not([' + ATTR + ']):not([' + ATTR_PROCESSING + '])'
        )
        .forEach(enhanceContainer);
      placeAllWrappersForViewport();
    } finally {
      if (globalMo) {
        globalMo.observe(document.documentElement, { childList: true, subtree: true });
      }
    }
  }

  function scheduleScanDebounced() {
    if (debounceId) {
      clearTimeout(debounceId);
    }
    debounceId = setTimeout(function () {
      debounceId = null;
      scan();
    }, 300);
  }

  function onDocumentMutated() {
    stashAllHeaderWeglotForMobile();
    scheduleScanDebounced();
  }

  function init() {
    scan();
    placeAllWrappersForViewport();
    notifyIfHeaderWeglotAlreadyEnhanced();
    bindMenuDrawerResync();
    bindWeglotLifecycle();

    globalMo = new MutationObserver(function () {
      onDocumentMutated();
    });
    globalMo.observe(document.documentElement, { childList: true, subtree: true });

    if (!resizeBound) {
      resizeBound = true;
      window.addEventListener('resize', scheduleScanDebounced, { passive: true });
    }

    window.addEventListener('load', scheduleScanDebounced, { passive: true });
    document.addEventListener('shopify:section:load', scheduleScanDebounced);

    // Weglot peut injecter tardivement (pages lourdes type « découvrir »)
    [800, 2000, 4000, 6000, 10000, 15000].forEach(function (ms) {
      setTimeout(function () {
        scan();
        placeAllWrappersForViewport();
        notifyIfHeaderWeglotAlreadyEnhanced();
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
